import { GetAccountSentimentReportPercentilesSummaryQuery } from '../../../../src/interface/queries/sentiment/get-account-sentiment-report-percentiles-summary.query';
import { LogManager } from '../../../../src/common/port/log/log.manager.port';
import { AccountSentimentReportPercentilesSummaryAggregateRootMapper } from '../../../../src/infrastructure/mappers/sentiment/account-sentiment-report-percentiles-summary-aggregate-root.mapper';
import { GetAccountSentimentReportPercentilesSummaryRequestDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-percentiles-summary.request.dto';
import { GetAccountSentimentReportPercentilesSummaryResponseDto } from '../../../../src/interface/dtos/sentiment/get-account-sentiment-report-percentiles-summary.response.dto';

export class GetAccountSentimentReportPercentilesSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountSentimentReportPercentilesSummaryQuery,
    protected readonly mapper: AccountSentimentReportPercentilesSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountSentimentReportPercentilesSummaryRequestDto
  ): Promise<GetAccountSentimentReportPercentilesSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountSentimentReportPercentilesSummaryController.get encountered an error ${error}`
      );
    }
  }
}
